import * as React from 'react';
import { useLiveOperation, useSpaceState } from '../../userHooks'
import './index.css'

const DecorationSpaceLiveModeLayout = () => {
    const { liveExit } = useLiveOperation()
    const setSpaceState = useSpaceState()[1]

    return <div className="panel decoration-space-panel__bottom--live">
        <div className='bottom'>
            <div className='controls'>
                <div className='collapsible-list'>
                    <div className='collapsible-item'>
                        <span>decoration -- live</span>
                        <button onClick={() => setSpaceState({ type: 'default' } )}>switch to default space</button>
                        <button onClick={() => liveExit()}>exit live</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
};

export default DecorationSpaceLiveModeLayout;
